"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CommandWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _CommandWindowModule = _interopRequireDefault(require("./CommandWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _CommandWindow = _interopRequireDefault(require("./CommandWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var COMMANDS_MAX_PAGE = 6;
/*
TODOS:
- when clicking a set command, drag mode is activated (command follows mouse)
- when clicking a non-set command, its focused for edit mode (hover-effect is static)
- when clicking emotion/action, drag mode is activated
- right cliking any, will trigger the thing
*/

function CommandWindow(_ref) {
  var _ref$initialTab = _ref.initialTab,
      initialTab = _ref$initialTab === void 0 ? "EMOTION" : _ref$initialTab,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var changeTab = (0, _react.useCallback)(function (tab) {
    setCurrentPage(1);
    setCurrentTab(tab);
  }, []);
  var increasePage = (0, _react.useCallback)(function (value) {
    if (currentTab !== "COMMAND") return;
    var newVal = currentPage + (value || 1);

    if (newVal > COMMANDS_MAX_PAGE) {
      setCurrentPage(1);
    } else if (newVal < 1) {
      setCurrentPage(COMMANDS_MAX_PAGE);
    } else {
      setCurrentPage(newVal);
    }
  }, [currentPage, currentTab]);
  var editFocusedCommand = (0, _react.useCallback)(function () {
    // eslint-disable-next-line no-console
    console.log("TODO");
  }, []);
  var renderEmotions = (0, _react.useCallback)(function () {
    /*
        TODO: Tooltips
        Laugh
        Sigh
        Wave
        Point
        Agree
        Deny
        Charge
        */
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_1,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col1)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_2,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col2)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_3,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col3)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_4,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col4)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_5,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col5)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_6,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col1)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_EMOTION_ICON_7,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col2)
    }));
  }, []);
  var renderActions = (0, _react.useCallback)(function () {
    /*
        TODO: Tooltips
        Trade
        Revive
        Current Location
        Follow Target
        Current Game Time
         Request GM
        Binding
        Create Logfile
        Torch
        Private Shop
        */
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_TRADE,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col1)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_REVIVAL,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col2)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_COORDINATES,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col3)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_FOLLOW,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col4)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_TIME,
      className: (0, _classnames.default)(_CommandWindowModule.default.row1, _CommandWindowModule.default.col5)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_HELP,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col1)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_BIND,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col2)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_LOG,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col3)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_TORCH,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col4)
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.CMD_ACTION_PRIVATE,
      className: (0, _classnames.default)(_CommandWindowModule.default.row2, _CommandWindowModule.default.col5)
    }));
  }, []);
  var renderCommands = (0, _react.useCallback)(function () {
    var buttons = [];

    for (var row = 1; row <= 2; row += 1) {
      for (var col = 1; col <= 5; col += 1) {
        buttons.push( /*#__PURE__*/_react.default.createElement(_Button.default, {
          key: "".concat(row, "_").concat(col),
          type: _EButtonType.default.CMD_ICON,
          className: (0, _classnames.default)(_CommandWindowModule.default["row".concat(row)], _CommandWindowModule.default["col".concat(col)])
        }, "\xA0"));
      }
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttons);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommandWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _CommandWindowModule.default.dragHandler,
    classNameCloseBtn: _CommandWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommandWindowModule.default.tabs
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    isDisabled: currentTab === "EMOTION",
    onClick: function onClick() {
      return changeTab("EMOTION");
    }
  }, "Emotion"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    isDisabled: currentTab === "ACTION",
    onClick: function onClick() {
      return changeTab("ACTION");
    }
  }, "Action"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB,
    isDisabled: currentTab === "COMMAND",
    onClick: function onClick() {
      return changeTab("COMMAND");
    }
  }, "Command")), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommandWindowModule.default.content
  }, currentTab === "EMOTION" && renderEmotions(), currentTab === "ACTION" && renderActions(), currentTab === "COMMAND" && renderCommands()), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommandWindowModule.default.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_LEFT,
    className: _CommandWindowModule.default.btnLeft,
    isDisabled: currentTab !== "COMMAND",
    onClick: function onClick() {
      return increasePage(-1);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommandWindowModule.default.currentPage
  }, currentPage), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_RIGHT,
    className: _CommandWindowModule.default.btnRight,
    isDisabled: currentTab !== "COMMAND",
    onClick: increasePage
  }), currentTab === "COMMAND" && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_MAIN_EDIT,
    className: _CommandWindowModule.default.btnEdit,
    onClick: editFocusedCommand
  }, formatMessage(_CommandWindow.default.edit))));
}